<!--
用于OEM考卷题目预揽
-->
<template>
  <div class="container" style="margin-top:24px;">
    <div class="practice-header">
      <div class="practice-title">
        <h1>{{ simInfo.examName }}</h1>
        <div class="practice-title-note">
          <div class="practice-title-note">
            <span style="margin-right: 30px"
              >答题时间：{{ simInfo.examTime }} 分钟</span
            >
            <span style="margin-right: 30px"
              >总题数：{{ simInfo.exerNum }} 题</span
            >
            <span style="margin-right: 30px"
              >总分：{{ simInfo.totalScore }} 分</span
            >
            <span style="margin-right: 30px">类别：{{ simInfo.simType }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="practice-container clearfix">
      <div class="fl practice-main">
        <div class="practice-nodata" v-show="exerciseList.length == 0">
          <img src="../../assets/images/nodata-03.png" alt="no-data" />
          <p>老师正在抓紧制作中...... 敬请期待！</p>
        </div>
        <div
          class="practice-item"
          style="user-select: none"
          onselectstart="return false;"
          unselectable="on"
          v-for="(data, index) in exerciseList"
          :key="index"
        >
          <div class="practice-item-header">
            <span class="practice-item-num">{{ index + 1 }}</span>
            <span class="practice-item-title">
              <span>【{{ data.keyType }}】</span>
              <span style="color: #f37b1d">(总分{{ data.exerScore }}分)</span>
              <div class="title-text" v-html="data.title"></div>
              <template v-if="data.eContent">
                <span
                  class="practice-item-view"
                  @click="data.titleVisible = true"
                  >查看题干</span
                >
                <Drawer
                  title="查看题干"
                  :closable="false"
                  width="700"
                  v-model="data.titleVisible"
                >
                  <div v-html="data.eContent"></div>
                </Drawer>
              </template>
            </span>
          </div>
          <ul
            class="practice-item-option"
            ref="option"
            v-if="optionType(data) == 1 || optionType(data) == 2"
          >
            <li v-if="data.a">
              <label>
                <input
                  :name="data.exerId"
                  type="radio"
                  :disabled="disabled"
                  value="A"
                />
                <i>A</i>
                <div class="item-text" v-html="data.a"></div>
              </label>
            </li>
            <li v-if="data.b">
              <label>
                <input
                  :name="data.exerId"
                  type="radio"
                  :disabled="disabled"
                  value="B"
                />
                <i>B</i>
                <div class="item-text" v-html="data.b"></div>
              </label>
            </li>
            <li v-if="data.c">
              <label>
                <input
                  :name="data.exerId"
                  type="radio"
                  :disabled="disabled"
                  value="C"
                />
                <i>C</i>
                <div class="item-text" v-html="data.c"></div>
              </label>
            </li>
            <li v-if="data.d">
              <label>
                <input
                  :name="data.exerId"
                  type="radio"
                  :disabled="disabled"
                  value="D"
                />
                <i>D</i>
                <div class="item-text" v-html="data.d"></div>
              </label>
            </li>
            <li v-if="data.e">
              <label>
                <input
                  :name="data.exerId"
                  :type="'radio'"
                  :disabled="disabled"
                  value="E"
                />
                <i>E</i>
                <div class="item-text" v-html="data.e"></div>
              </label>
            </li>
            <li v-if="data.f">
              <label>
                <input
                  :name="data.exerId"
                  :type="radio"
                  :disabled="disabled"
                  value="F"
                />
                <i>F</i>
                <div class="item-text" v-html="data.f"></div>
              </label>
            </li>
            <li v-if="data.g">
              <label>
                <input
                  :name="data.exerId"
                  type="radio"
                  :disabled="disabled"
                  value="G"
                />
                <i>G</i>
                <div class="item-text" v-html="data.g"></div>
              </label>
            </li>
            <li v-if="data.h">
              <label>
                <input
                  :name="data.exerId"
                  type="radio"
                  :disabled="disabled"
                  value="H"
                />
                <i>H</i>
                <div class="item-text" v-html="data.h"></div>
              </label>
            </li>
          </ul>
          <div class="practice-item-result">
            <div class="practice-item-answer">
              <p v-if="optionType(data) != 3">
                <span class="symbol">[结果]</span>正确答案是：
                <span class="answer">{{ data.rightKey }}</span>
              </p>
              <div>
                <span class="symbol">[解析]</span>
                <template v-if="data.jContent">
                  <span
                    class="practice-item-view"
                    @click="data.analyzeVisible = true"
                    >查看解析</span
                  >
                  <Drawer
                    title="查看解析"
                    :closable="false"
                    width="700"
                    v-model="data.analyzeVisible"
                  >
                    <div v-html="data.jContent"></div>
                  </Drawer>
                </template>
                <div class="analyze-text" v-else v-html="data.analyze"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fr practice-bar">
        <Affix :offset-top="20">
          <div class="practice-sheet">
            <h3 class="practice-sheet-header">答题卡</h3>
            <p class="practice-sheet-note">点击图标跳转到对应的题目</p>
            <div class="practice-sheet-list" style="height:500px;">
              <happy-scroll
                color="rgba(12, 154, 213 , 1)"
                size="5"
                resize
                hide-horizontal
              >
                <!-- 答题卡 -->
                <div
                  v-if="exerciseList.filter((m) => m.optionType === 1).length"
                >
                  单选题
                </div>
                <ul
                  class="practice-sheet-serial clearfix"
                  style="padding-bottom:0"
                >
                  <li
                    v-for="item in exerciseList.filter(
                      (m) => m.optionType === 1
                    )"
                    :key="item.serial"
                  >
                    <a
                      v-text="item.serial + 1"
                      @click="scrollPosition(item.serial)"
                    ></a>
                  </li>
                </ul>
                <div
                  v-if="exerciseList.filter((m) => m.optionType === 2).length"
                >
                  多选题
                </div>
                <ul
                  class="practice-sheet-serial clearfix"
                  style="padding-bottom:0"
                >
                  <li
                    v-for="item in exerciseList.filter(
                      (m) => m.optionType === 2
                    )"
                    :key="item.serial"
                  >
                    <a
                      v-text="item.serial + 1"
                      @click="scrollPosition(item.serial)"
                    ></a>
                  </li>
                </ul>
                <div
                  v-if="exerciseList.filter((m) => m.optionType === 3).length"
                >
                  主观题
                </div>
                <ul class="practice-sheet-serial clearfix">
                  <li
                    v-for="item in exerciseList.filter(
                      (m) => m.optionType === 3
                    )"
                    :key="item.serial"
                  >
                    <a
                      v-text="item.serial + 1"
                      @click="scrollPosition(item.serial)"
                    ></a>
                  </li>
                </ul>
              </happy-scroll>
            </div>
          </div>
        </Affix>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { HappyScroll } from "vue-happy-scroll";
import { oem } from "../../request";
import "vue-happy-scroll/docs/happy-scroll.css";
export default {
  name: "ExercisePreview",
  mixins: [siteMixin],
  components: {
    HappyScroll,
  },
  data() {
    return {
      simId: "",
      disabled: true,
      exerciseList: [],
      simInfo: {},
    };
  },
  mounted() {
    const simId = this.$route.query.simId;
    if (simId) {
      this.simId = simId;
      this.getData();
    } else {
      this.$message.error("参数错误");
    }
  },
  methods: {
    optionType(data) {
      if (
        data.keyType == "单选" ||
        data.keyType == "判断" ||
        data.keyType == "多选" ||
        data.newKeyType == "1" ||
        data.newKeyType == "2"
      ) {
        if (data.rightKey && data.rightKey.length > 1) {
          return 2;
        } else {
          return 1;
        }
      } else {
        return 3;
      }
    },
    getData() {
      oem.getSimExerciseList(this.simId).then((res) => {
        console.log("res", res);
        if (res.status === 1) {
          const {
            examName,
            examTime,
            exerNum,
            list,
            totalScore,
            simType,
          } = res.data;
          this.setMetaData(examName);
          this.simInfo = { examName, examTime, exerNum, totalScore, simType };
          this.exerciseList = list.map((m, index) => {
            const type = this.optionType(m);
            return {
              ...m,
              serial: index,
              optionType: type,
              titleVisible: false,
              analyzeVisible: false,
            };
          });
        }
      });
    },
    scrollPosition(i) {
      var top = document.querySelectorAll(".practice-item")[i].offsetTop;
      window.scroll({ top: top, left: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
@import "../../assets/css/exercise";
.practice-nodata {
  padding: 35px;
  img {
    margin: 0 auto;
  }
  p {
    margin-top: 16px;
    text-align: center;
    font-size: 1.8rem;
  }
}
.practice-item {
  width: 100%;
  padding: 35px 0;
  background-color: #fff;
  & + & {
    border-top: 1px solid #e6e6e6;
  }
  .practice-item-num {
    color: #0195d3;
    font-weight: bold;
  }
  .practice-item-title {
    margin-left: 10px;
    & > span {
      color: #0195d3;
      margin-right: 5px;
    }
    .title-text {
      .inline-block();
      /deep/img {
        .inline-block();
      }
    }
  }
  .practice-item-view {
    float: right;
    background-image: url(data:image/png;base64,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);
    background-position: left center;
    background-size: 18px;
    background-repeat: no-repeat;
    padding-left: 22px;
    color: #3e8bff;
    cursor: pointer;
  }
  .practice-item-option {
    margin-left: 12px;
    padding: 15px 0;
    label {
      font-size: 1.6rem;
      cursor: pointer;
      font-weight: normal;
      i {
        width: 26px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #666;
        vertical-align: middle;
        display: inline-block;
        margin: 0 10px 3px 0;
        border: 1px solid #fff;
        font-style: normal;
        text-align: center;
      }
      input[type="checkbox"],
      input[type="radio"] {
        display: none;
      }
      input[type="checkbox"] + i {
        border-radius: 3px;
      }
      input[type="radio"] + i {
        border-radius: 20px;
      }
      input[type="checkbox"]:checked + i,
      input[type="radio"]:checked + i {
        background: #0195d3;
        border-color: #0195d3;
        color: #fff;
      }
      input[type="checkbox"]:disabled + i,
      input[type="radio"]:disabled + i {
        border-color: #fff;
      }
      input[type="checkbox"]:checked:disabled + i,
      input[type="radio"]:checked:disabled + i {
        background: #0195d3;
      }
      .item-text {
        display: inline-block;
        vertical-align: middle;
        /deep/img {
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
  .practice-item-result {
    position: relative;
    margin-top: 20px;
    padding: 15px 10px;
    border-radius: 5px;
    background-color: #e6e6e6;
    font-size: 1.5rem;
    .practice-item-answer {
      // margin-left: 60px;
      &.no-result {
        margin-left: 5px;
      }
      .symbol {
        font-weight: bold;
        color: #999;
        margin-right: 5px;
      }
      .answer {
        color: #0195d3;
      }
      .practice-item-view {
        float: none;
      }
      .analyze-text {
        width: 720px;
        .inline-block();
        vertical-align: top;
        /deep/img {
          .inline-block();
        }
      }
    }
    .practice-item-count {
      position: absolute;
      top: 30px;
      right: 15px;
    }
    .practice-item-star {
      .practice-item-star-icon {
        float: left;
        width: 60px;
        height: 60px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        // display: inline-block;
        // vertical-align: middle;
        margin-right: 10px;
        background-image: url(data:image/png;base64,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);
      }
      .practice-item-star-text {
        display: inline-block;
        vertical-align: middle;
        height: 32px;
        line-height: 36px;
        margin-right: 20px;
        margin-left: 8px;
      }
      .practice-item-star-list {
        display: inline-block;
        vertical-align: middle;
        height: 32px;
        &.sm {
          height: 24px;
          i {
            width: 24px;
            height: 24px;
            background-size: cover;
            &.active {
              background-size: cover;
            }
          }
        }
        i {
          display: inline-block;
          width: 32px;
          height: 32px;
          vertical-align: middle;
          cursor: pointer;
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAACNUlEQVRYhe3WPWgUQRjG8d+JkkIlIQrGjyJiYdBtFLRYAq5YKAhaJLWRIIqWYmEKLcVWQQuRYJXegIWg3Fq4hYJCXCEG7CwiKKSITQxqcRuNq3e3d3uJCj4wzPC+M+/8GWaeXf7rH1BlaVB9+qrdGmtwHA+iMPjSFkSl8r1QWe3BzawvpU7AXEV/1pdSWZijGM7Gw3GSHv1TMF245se9q+BanKRdfwLmHPbnYvuz+KrCbMNYndxYnKTbVhPmCvrq5Pqy/KrADGK0yZzROEkHWy3czPQq2IUB7EOIA9hUoPZHPEeCl5jG2ygMvv6ySWZ6a5fF1mEzdmMvDqpdyB3oKbB5XptwLGswh3dxkr7AM7zGG3zA5zzMTtzGkTY2LqKerAU4lcUe4wJm+PnOzOAiZlcIJq9ZXIzCYGYpkL/AUxhSO9KV1ByGojCYWh783WtKMIKFFQJZwEgUBkk+Ue9pT+L8CsGcj8Jg8neJRj4zrr7LtquxKAzG6yWbmd513OgQyI0oDK43mlDEgS+hWhKkmtVpqCIwi8q/rrkoDBY7AQNbS8LU+6j+pCIw69FdjkVPnKTrOwGzZOOlYIrUKALTjd6SML0KnG5RmEb/tSluZX09dRWBWdtsArbUiT/BHTW3nscGnMBZHGqhTksw25eNP+E+7sp5TxQG85jARJykh3EGJ9UeQL5O2zD9eI97WZtutiAKgyqqcZIO4HTW+jsBk+AhHhWYm4eaxuU4SR9hY6vr/+uv1Dcuk3HZavmvQgAAAABJRU5ErkJggg==);
          &.active {
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAEbUlEQVRYhe2XTWxUVRTHf//75s2AbZ2h1Fo+IvWbCJpYozGGhBAXkBh1AboyQoiR4MaEsLALiCvCVhcujEEWBhcmRjEuiGhl04UmGBEMEIRIMFKgpNNh2s7Me/e4eO102plh+oGJJvyTl/l4557ze/eee859cFf/A2nqy+bPjXIMHcuNjk5x5azRlhFpB2nAmvtw+ZiXsgHfAr5ZkDJQ9lAsGavXisJNY3RYuAz88FqCkWpFWjEYiyFqECYTQBjwRGT+wxLuUiXmdCmut0s5CIOaJ2+i28IAFCJ4Yx2sydbfO3kVvrlg+9Oi90bJ9r/8iF7v66m3+zMPn52BjmCRMLGHR5dB3/31964V2VyObVsmhHJk21Z3aPPzKzg22y7tEj8sFmZJCt4fNLKBCHySO0rmO5OP7EB7mMx+e4g+/dUOfHlGPwIls2RZYgf52FiSarVI4FpakDgteChnIL4HSiGMxuzyWJ9qbDzWN+rZVQoTu3ImGdcaYz4wAjOjq9tY0wu5ZayMIt8/O4iAqOL7c8tYuaYXuroNM5uayTsDA4BBIQ9D12F42PYpoEGqghw9w8O2b+h6Yn+7mrBwGCCKYKzAholx29nsYSWYGLedYwU2RNF8vDdIYAncNKKAhzHWSjw9VuQFwz/rRPp2Tp1IT4z7r4R+lhjE+AU4C/wBmHM0XLpamBDRVSnxeDFv6+R4biK2Po+tBnIAkU06aZUDAu9ZbmZbJLYAeGxkAl2R42Qxbz9VSpyROAfcACozYAwelOyjsYK9WBxNZmd20Z1rIjaxz3ksJ8f64b95UwIFfA96BzgPNTljcB5pj8RVN69Mmr8ml+mqpD2mBGQGTEqQEqfCQFsdjPyrMDASBtqaEqdqa2F1mZ65L/kMnAbPF9n+14h9EbRI1IUoNso9OW1/rE2DsQcE301DJgpdcqUFYVpHg0C77zQIQBBod5jW0bQmY9bMTG3OTF8GMh0Srv9OggjXL9Mhs5nxpjS9taPqCHwFojJgHDRcTxD6d+e7k2plBnHFfSA4OOWfgLrqXIUJ+qosrIqhs5T8drD34m96avSGbXItjgCN5GO4t0sDDz3J3qlSsTQDCupPFFWYC5en/3RMV2EHUVxmZM6td7YEcZmRsZvTh8VbHoYamFZhrpxr7s/HrFho7XEOxov0XPy9tW0Vxjfvrm2I7Hy6b51EzkOboDgnGPmGB3uAnE32pgXLLCezHC1gavqzml1ZoHNRMNCJlG0aY1LVmWlf0jhDY092rGSZZlEEp5FOYLbRYH0Ts4wCZef8qlKqNDbwRoP3AnDoBI6PQUcxu4Vz7cJewfO2xzbWDWjipyFMpcHL16RWYWACQdGjr7uX6pOowkA+nnG+vWXGkWxKR1KhNl0bt7cc9qpBGwbmWdVqD0yfZ6ypaa8LGArQ4chxmIizKUHcZM6VdP8BYEAprQ09O2Jsh/fW24KlZjc127tisLvXHStctuNTHaPVE9bcP5t2vNfxgDs+dMl3LKo83NV/Rf8AK06f+DS3QVMAAAAASUVORK5CYII=);
          }
        }
      }
    }
  }
}
</style>
